import React, { useEffect, useState } from "react";
import { X, Wand2 } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { setShowWizard } from "../../../store/slices/WizardSlice/WizardSlice";
import NewClient from "./NewClient";
import ExistingClient from "./ExistingClient";
import { setCreatedProject, setWizardPlanState, setWizardProjectState } from "../../../store/slices/WizardSlice/wizardStepSlice";
import { useNavigate } from "react-router-dom";
import useSubscriptionLevel from "../../../utils/SubscriptionLevel";
import { useLoggedUser } from "../../../utils/useLoggedUser";
import { getFeatureAccessLevel } from "../../../utils/featureAccessUtils";
// import QuotationNumber from "./QuotationNumber";

const Wizard = () => {
    const subscriptionPackage = useSubscriptionLevel()
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const newClient = useSelector((state) => state.wizard.newClient);
    const existingClient = useSelector((state) => state.wizard.existingClient);
    const [showWizard, setshowWizard] = useState(true)
    const wizardPlanState = useSelector((state) => state.wizardstep.wizardPlanState);
    const loggedUser = useLoggedUser();
    const hasNoFeatureConfig = !loggedUser?.featureAccess || loggedUser.featureAccess.length === 0;
    const wizardAccessLevel = getFeatureAccessLevel(loggedUser, "WIZARD WIZARD FEATURE");
    const isWizardViewOnly =
        !hasNoFeatureConfig &&
        wizardAccessLevel &&
        String(wizardAccessLevel).trim().toUpperCase() === "VIEW ONLY";
    // const [wizardShowHide, setWizardShowHide] = useState(true)

    useEffect(() => {
        if (subscriptionPackage === "CRM") {
            dispatch(setWizardPlanState("basicplan"));
        }
        if (subscriptionPackage === "ERP") {
            dispatch(setWizardPlanState("advancedplan"));
        }
    }, [subscriptionPackage, dispatch])

    return (
        <>
            {showWizard && (
                <>
                    <div className="w-[16%] top-1 left-2 fixed rounded-md shadow-lg bg-gradient-to-b from-blue-500 to-blue-400 text-white p-4  z-[2200]">
                        <div className="flex relative ">
                            <div>
                                <button
                                    onClick={() => {
                                        dispatch(setShowWizard(false));
                                        dispatch(setWizardPlanState(""));
                                        dispatch(setCreatedProject([]));
                                    }}
                                    className="absolute top-1 right-0 text-white/80 hover:text-white">
                                    <X size={16} />
                                </button>
                            </div>

                            <div className="flex items-center gap-1 mb-4">
                                <Wand2 size={20} />
                                <h2 className="font-semibold text-sm">
                                    Wizard{" "}
                                    {/* <span className="text-xs">
                                        {wizardPlanState
                                            ? wizardPlanState === "advancedplan"
                                                ? "(Advanced Plan)"
                                                : wizardPlanState === "basicplan"
                                                    ? "(Basic Plan)"
                                                    : ""
                                            : ""}
                                    </span> */}
                                </h2>
                            </div>
                        </div>
                        {/* {wizardShowHide && (
                            <div className="flex flex-col gap-2 pb-3">
                                {!wizardPlanState && (
                                    <>
                                        <button
                                            onClick={() => {
                                                dispatch(setWizardPlanState("basicplan"));
                                                setWizardShowHide(false)
                                            }}
                                            className="cursor-pointer bg-white text-gray-800 hover:bg-blue-100 py-1.5 rounded-md text-sm shadow-sm transition-all">
                                            Base Plan
                                        </button>
                                        <button
                                            onClick={() => {
                                                dispatch(setWizardPlanState("advancedplan"));
                                                setWizardShowHide(false)
                                            }}
                                            className="cursor-pointer bg-white text-gray-800 hover:bg-blue-100 py-1.5 rounded-md text-sm shadow-sm transition-all">
                                            Advanced Plan
                                        </button>
                                    </>
                                )}
                            </div>
                        )} */}

                        {wizardPlanState === "basicplan" && (
                            <div className="flex flex-col gap-2 pb-3">
                                <button
                                    onClick={() => {
                                        if (isWizardViewOnly) return;
                                        dispatch(setWizardProjectState("newProject"))
                                        navigate("/dashboard/wizard");
                                        setshowWizard(false)
                                    }}
                                    disabled={isWizardViewOnly}
                                    className={`py-1.5 rounded-md text-sm shadow-sm transition-all ${isWizardViewOnly
                                        ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-70"
                                        : "cursor-pointer bg-white text-gray-800 hover:bg-blue-100"
                                        }`}>
                                    New Project
                                </button>
                                <button
                                    onClick={() => {
                                        if (isWizardViewOnly) return;
                                        dispatch(setWizardProjectState("existingProject"))
                                        navigate("/dashboard/wizard")
                                        setshowWizard(false)
                                    }}
                                    disabled={isWizardViewOnly}
                                    className={`py-1.5 rounded-md text-sm shadow-sm transition-all ${isWizardViewOnly
                                        ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-70"
                                        : "cursor-pointer bg-white text-gray-800 hover:bg-blue-100"
                                        }`}>
                                    Existing Project
                                </button>
                            </div>
                        )}

                        {wizardPlanState === "advancedplan" && (
                            <div className="flex flex-col gap-2 pb-3">
                                <button
                                    onClick={() => {
                                        if (isWizardViewOnly) return;
                                        dispatch(setWizardProjectState("newProject"))
                                        navigate("/dashboard/wizard");
                                        setshowWizard(false)
                                    }}
                                    disabled={isWizardViewOnly}
                                    className={`py-1.5 rounded-md text-sm shadow-sm transition-all ${isWizardViewOnly
                                        ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-70"
                                        : "cursor-pointer bg-white text-gray-800 hover:bg-blue-100"
                                        }`}>
                                    New Project
                                </button>
                                <button
                                    onClick={() => {
                                        if (isWizardViewOnly) return;
                                        dispatch(setWizardProjectState("existingProject"))
                                        navigate("/dashboard/wizard")
                                        setshowWizard(false)
                                    }}
                                    disabled={isWizardViewOnly}
                                    className={`py-1.5 rounded-md text-sm shadow-sm transition-all ${isWizardViewOnly
                                        ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed opacity-70"
                                        : "cursor-pointer bg-white text-gray-800 hover:bg-blue-100"
                                        }`}>
                                    Existing Project
                                </button>
                            </div>
                        )}
                    </div>

                </>
            )}

            {newClient && (
                <NewClient setshowWizard={setshowWizard} />
            )}

            {existingClient && (
                <ExistingClient setshowWizard={setshowWizard} />
            )}

            {/* {quotationNumber && (
                <QuotationNumber setshowWizard={setshowWizard} />
            )

            } */}
        </>
    );
};

export default Wizard;
